import React, { useContext } from 'react';

import { Button } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/RevisionStatus';

import { RevisionContext } from '../RevisionActions/RevisionActions';

import styles from './ControlPanel.module.scss';

const t = i18n(keyset);

interface Props {
    revisionId: string;
    disabled: boolean;
}

export const RevisionControl = ({ revisionId, disabled }: Props) => {
    const { handleMoveToDraft, handleOpenPublishRevisionModal } = useContext(RevisionContext);

    return (
        <div>
            <div className={styles.buttonsContainer}>
                <Button type="submit" onClick={() => handleMoveToDraft(revisionId)} disabled={disabled}>
                    {t('revision-move-to-draft')}
                </Button>
                <Button view={'action'} onClick={() => handleOpenPublishRevisionModal(revisionId)} disabled={disabled}>
                    {t('revision-make-active')}
                </Button>
            </div>
        </div>
    );
};
